
export const refreshInterval = 60 * 1000;

export const EMPTY_STRING = "";

export const ERROR_METRIC_SUFFFIX = "Error";

export const HYPHEN = "-";

export const MISSING = "MISSING"

export const TOTAL = "Total"

export const PACKAGE_STATUS = "PACKAGE_STATUS"

export const STATION_PAIR = "STATION_PAIR"

export const FLOOR = "FLOOR"

export const FLOOR_LOCATION = "FLOOR_LOCATION"

export const GROUP_BY = "GROUP_BY"

export const CYCLE = "CYCLE"

export const CYCLE_ID = "CYCLE_ID"

export const FALSE = "FALSE"

export const True = "true"

export const TRUE = "TRUE"

export const TIMEOUT_STRING = "timeout";

export const NOT_AVAILABLE = "NA";

export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour:'2-digit',
    minute:'2-digit',
    second:'2-digit',
    timeZoneName: 'short',
    hourCycle:'h24'
}

export const DARK_MODE = {
    DARK: "dark",
    LIGHT: "light"
}

export const CONSTANT_FILTERS = ["cycle", "cycleId","CPT","CPTId"]

export const OPTIONS_TAG_REQUIRED = ["cycle", "clusters", "associateStatuses", "aisle", "CPT"]

export const OPTIONS_TAG_REQUIRED_STOW_BUFFER = ["cycle", "machineStatuses"]

export const HEADERS = {
    ASSOCIATE : {
        tab: "associate.tabHeading",
        tabAlt: "Associate",
        head: "associate.heading",
        headAlt: "Associates",
        desc: "associate.description",
        descAlt: "This table shows stow associates’ performance data and current working location."
    },
    HEATMAP : {
        tab: "heatMap.tabHeading",
        tabAlt: "Inbound",
        head: "heatMap.heading",
        headAlt: "Stow",
        desc: "heatMap.description",
        descAlt: "This table shows the clusters and statuses of containers and packages in the stow process."
    },
    STOW_BUFFER : {
        tab: "stowBuffer.tabHeading",
        tabAlt: "Associate",
        head: "stowBuffer.heading",
        headAlt: "Stow Buffer",
        desc: "stowBuffer.description",
        descAlt: "This table shows ADTA Finger level metrics"
    },
}

export const DEFAULT_JACKPOT_BAY_NAME = "Jackpot Bay";

export const FEATURES = {
    ADTA_VISIBILITY: "isADTAVisibilityEnabled",
    IS_CPT_FILTER_ENABLED: "isCPTFilterEnabled",
    DRS_STOW_VISIBILITY: "isDRSStowVisibilityEnabled",
    GRID_ALLOCATION_VIEW_ENABLED: "isGridAllocationViewEnabled",
    SIDELINE_STOW_VISIBILITY: "isSidelineStowVisibilityEnabled",
    SIDELINE_STOW_V2: "isSidelineStowVisibilityV2Enabled",
    STOW_BREAKDOWN_V2: "isAllStowLocationsVisibilityEnabled",
    REINDUCT_DATE_PLUS_ONE_FIX: "isReInductDatePlusOneFixEnabled",
    CART_VISIBILITY: "isCartVisibilityEnabled",
    ROUTE_CODE_VISIBILITY: "isRouteCodeVisibleForSSDStations",
    DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY: "isDownloadSortPlanButtonEnabled",
    IS_EMPTY_CYCLE_ALLOWED_ENABLED: "isEmptyCycleAllowedEnabled",
    IS_ASSOCIATE_SCAN_METRIC_ENABLED: "isAssociateScanMetricEnabled"
}



// WEBPACK FOOTER //
// ./src/constants.js